import * as ko from 'knockout';

import 'intl-tel-input';
import 'intl-tel-input-utils';
import {ZIndexManager} from 'Core/Common/ZIndexManager';

export class IntlTelInputExtention {
    static Init() {
        ko.bindingHandlers.intlTelInput = {
            init: (element, valueAccessor) => {
                const params = valueAccessor();
                const options = params.options;
                const isModal: boolean = !!options.isModal;
                const isDropdownContainer: boolean = !!options.dropdownContainer;
                const screen = options.screen;

                const iti = window.intlTelInput(element, options);

                const initialValue = ko.unwrap(params.value);
                const initialCountry = ko.unwrap(params.country);
                if (initialCountry && IntlTelInputExtention.IsCountryValid(initialCountry)) {
                    iti.setCountry(initialCountry);
                } else if (typeof initialValue === 'string' && initialValue.startsWith('+')) {
                    iti.setNumber(initialValue);
                }

                // if (options.dropdownContainer === document.body) {
                //     const $container = $(element).parent('.intl-tel-input');
                //
                //     $(element).on('open:countrydropdown', () => {
                //         const offset = $container.offset();
                //         const height = $container.outerHeight();
                //
                //         $(iti.dropdown).css({
                //             top: offset.top + height,
                //             left: offset.left,
                //             width: $container.outerWidth()
                //         });
                //     });
                // }
                
                const country = iti.getSelectedCountryData();

                if (options.inputClass) {
                    $(element).parent('.intl-tel-input').addClass(options.inputClass);
                }

                if (options.onlyFlagCountry) {
                    if ($(element).parent('.intl-tel-input').hasClass('separate-dial-code')) {
                        $(element).parent('.intl-tel-input').removeClass('separate-dial-code');
                    }
                    $(element).parent('.intl-tel-input').addClass('js-only-flag-country');
                }

                if (country) {
                    if (params.listener) {
                        params.listener(iti.getSelectedCountryData(), false);
                    }
                }

                $(element).on('countrychange', () => {
                    $(element).val('');

                    params.listener(iti.getSelectedCountryData(), true);
                });

                if (isModal && isDropdownContainer){
                    if (options.dropdownClass && iti.dropdown) {
                        $(iti.dropdown).addClass(options.dropdownClass);
                        $(iti.dropdown).find('.country-list').addClass('sps-scrollable-y');
                    }
                    $(iti.dropdown).css('zIndex', ZIndexManager.Instance.NextValue);

                    $(screen._modal._wrapper).parents('.jBox-content').on('scroll', () => this.OnScroll(iti));
                }
            }
        }
    }

    static OnScroll(iti) {
        iti._2();   //in the library this is key: "_closeDropdown";
                    //here you can take the developer file: https://cdnjs.com/libraries/intl-tel-input/14.0.6
    }

    static IsCountryValid(country: string): boolean {
        const allCountries = window.intlTelInputGlobals.getCountryData();
        const selectedCountry = _.find(allCountries, item => item.iso2 === country);
        return !!selectedCountry;
    }

    static GetCodeByIso2(iso2: string): string {
        const allCountries = window.intlTelInputGlobals.getCountryData();
        const selectedCountry = _.find(allCountries, item => item.iso2 === iso2);

        return selectedCountry ? selectedCountry.dialCode: '31';
    }
}